import React, { useContext } from "react";
import { defineMessages, IntlContext } from "react-intl";
import { GridOverlay } from "@mui/x-data-grid";
import { LocalizedText } from "../../../i18n/LocalizedText.js";
const localized = defineMessages({
  noRowsLabel: {
    id: "noRowsLabel",
    defaultMessage: "No rows"
  },
  columnMenuLabel: {
    id: "columnMenuLabel",
    defaultMessage: "Menu"
  },
  columnMenuFilter: {
    id: "columnMenuFilter",
    defaultMessage: "Filter"
  },
  columnMenuHideColumn: {
    id: "columnMenuHideColumn",
    defaultMessage: "Hide"
  },
  columnMenuUnsort: {
    id: "columnMenuUnsort",
    defaultMessage: "Unsort"
  },
  columnMenuSortAsc: {
    id: "columnMenuSortAsc",
    defaultMessage: "Sort by ASC"
  },
  columnMenuSortDesc: {
    id: "columnMenuSortDesc",
    defaultMessage: "Sort by DESC"
  },
  displayedRowsLabel: {
    id: "displayedRowsLabel",
    defaultMessage: "of"
  },
  toolbarColumns: {
    id: "DataGridColumnsPanel_openPanel",
    defaultMessage: "Columns"
  }
});
const LocalizedNoRowsOverlay = () => {
  return /* @__PURE__ */ React.createElement(GridOverlay, null, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.noRowsLabel }));
};
const useGridLocalization = () => {
  const { formatMessage } = useContext(IntlContext);
  const localeText = {
    columnMenuLabel: formatMessage(localized.columnMenuLabel),
    columnMenuFilter: formatMessage(localized.columnMenuFilter),
    columnMenuHideColumn: formatMessage(localized.columnMenuHideColumn),
    columnMenuUnsort: formatMessage(localized.columnMenuUnsort),
    columnMenuSortAsc: formatMessage(localized.columnMenuSortAsc),
    columnMenuSortDesc: formatMessage(localized.columnMenuSortDesc),
    toolbarColumns: formatMessage(localized.toolbarColumns)
  };
  const getLabelDisplayedRows = ({ from, to, count }) => {
    return `${from}-${to}${count !== -1 ? ` ${formatMessage(localized.displayedRowsLabel)} ${count}` : ""}`;
  };
  return {
    localeText,
    components: { noRowsOverlay: LocalizedNoRowsOverlay },
    getLabelDisplayedRows
  };
};
export {
  useGridLocalization
};
//# sourceMappingURL=useGridLocalization.js.map
